// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bulk Operation Details Modal Styles */
.bulk-operation-details-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.bulk-operation-details-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.bulk-operation-details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.bulk-operation-details-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a202c;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #718096;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.2s;
}

.close-button:hover {
  background-color: #e2e8f0;
  color: #2d3748;
}

.bulk-operation-details-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.5rem;
}

.details-section {
  margin-bottom: 1.5rem;
}

.details-section:last-child {
  margin-bottom: 0;
}

.details-section h4 {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 0.5rem;
}

.details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.detail-item label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #4a5568;
}

.detail-item span {
  font-size: 0.875rem;
  color: #2d3748;
}

.status-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.status-badge.completed {
  background-color: #c6f6d5;
  color: #22543d;
}

.status-badge.in_progress {
  background-color: #fef5e7;
  color: #744210;
}

.status-badge.failed {
  background-color: #fed7d7;
  color: #742a2a;
}

.status-badge.pending {
  background-color: #edf2f7;
  color: #2d3748;
}

.progress-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background-color: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background-color: #4299e1;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 0.875rem;
  color: #4a5568;
  text-align: center;
}

.results-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}

.result-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  border-radius: 8px;
  text-align: center;
}

.result-item.success {
  background-color: #f0fff4;
  border: 1px solid #c6f6d5;
}

.result-item.failed {
  background-color: #fff5f5;
  border: 1px solid #fed7d7;
}

.result-item.skipped {
  background-color: #f7fafc;
  border: 1px solid #e2e8f0;
}

.result-count {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
}

.result-item.success .result-count {
  color: #22543d;
}

.result-item.failed .result-count {
  color: #742a2a;
}

.result-item.skipped .result-count {
  color: #4a5568;
}

.result-label {
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.result-item.success .result-label {
  color: #22543d;
}

.result-item.failed .result-label {
  color: #742a2a;
}

.result-item.skipped .result-label {
  color: #4a5568;
}

.error-message {
  background-color: #fed7d7;
  border: 1px solid #feb2b2;
  border-radius: 6px;
  padding: 1rem;
  font-size: 0.875rem;
  color: #742a2a;
  white-space: pre-wrap;
}

.parameters-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.parameter-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background-color: #f7fafc;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.parameter-item label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #4a5568;
  margin: 0;
}

.parameter-item span {
  font-size: 0.875rem;
  color: #2d3748;
  font-family: 'Courier New', monospace;
  background-color: #edf2f7;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
}

.bulk-operation-details-footer {
  padding: 1.5rem;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  display: flex;
  justify-content: flex-end;
}

.btn {
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}

.btn-secondary {
  background-color: #edf2f7;
  color: #4a5568;
  border-color: #e2e8f0;
}

.btn-secondary:hover {
  background-color: #e2e8f0;
  color: #2d3748;
}

/* Responsive Design */
@media (max-width: 768px) {
  .bulk-operation-details-modal {
    width: 95%;
    max-height: 90vh;
  }
  
  .details-grid {
    grid-template-columns: 1fr;
  }
  
  .results-grid {
    grid-template-columns: 1fr;
  }
  
  .parameter-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/invoices/BulkOperationDetails.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qFAAqF;EACrF,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;AACF","sourcesContent":["/* Bulk Operation Details Modal Styles */\n.bulk-operation-details-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.bulk-operation-details-modal {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  max-width: 600px;\n  width: 90%;\n  max-height: 80vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.bulk-operation-details-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.bulk-operation-details-header h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #718096;\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.close-button:hover {\n  background-color: #e2e8f0;\n  color: #2d3748;\n}\n\n.bulk-operation-details-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.5rem;\n}\n\n.details-section {\n  margin-bottom: 1.5rem;\n}\n\n.details-section:last-child {\n  margin-bottom: 0;\n}\n\n.details-section h4 {\n  margin: 0 0 1rem 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #2d3748;\n  border-bottom: 1px solid #e2e8f0;\n  padding-bottom: 0.5rem;\n}\n\n.details-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.detail-item label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #4a5568;\n}\n\n.detail-item span {\n  font-size: 0.875rem;\n  color: #2d3748;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.status-badge.completed {\n  background-color: #c6f6d5;\n  color: #22543d;\n}\n\n.status-badge.in_progress {\n  background-color: #fef5e7;\n  color: #744210;\n}\n\n.status-badge.failed {\n  background-color: #fed7d7;\n  color: #742a2a;\n}\n\n.status-badge.pending {\n  background-color: #edf2f7;\n  color: #2d3748;\n}\n\n.progress-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background-color: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background-color: #4299e1;\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  font-size: 0.875rem;\n  color: #4a5568;\n  text-align: center;\n}\n\n.results-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n}\n\n.result-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1rem;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.result-item.success {\n  background-color: #f0fff4;\n  border: 1px solid #c6f6d5;\n}\n\n.result-item.failed {\n  background-color: #fff5f5;\n  border: 1px solid #fed7d7;\n}\n\n.result-item.skipped {\n  background-color: #f7fafc;\n  border: 1px solid #e2e8f0;\n}\n\n.result-count {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 0.25rem;\n}\n\n.result-item.success .result-count {\n  color: #22543d;\n}\n\n.result-item.failed .result-count {\n  color: #742a2a;\n}\n\n.result-item.skipped .result-count {\n  color: #4a5568;\n}\n\n.result-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.result-item.success .result-label {\n  color: #22543d;\n}\n\n.result-item.failed .result-label {\n  color: #742a2a;\n}\n\n.result-item.skipped .result-label {\n  color: #4a5568;\n}\n\n.error-message {\n  background-color: #fed7d7;\n  border: 1px solid #feb2b2;\n  border-radius: 6px;\n  padding: 1rem;\n  font-size: 0.875rem;\n  color: #742a2a;\n  white-space: pre-wrap;\n}\n\n.parameters-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.parameter-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem;\n  background-color: #f7fafc;\n  border-radius: 4px;\n  border: 1px solid #e2e8f0;\n}\n\n.parameter-item label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #4a5568;\n  margin: 0;\n}\n\n.parameter-item span {\n  font-size: 0.875rem;\n  color: #2d3748;\n  font-family: 'Courier New', monospace;\n  background-color: #edf2f7;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n}\n\n.bulk-operation-details-footer {\n  padding: 1.5rem;\n  border-top: 1px solid #e2e8f0;\n  background: #f8fafc;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.btn {\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 1px solid transparent;\n}\n\n.btn-secondary {\n  background-color: #edf2f7;\n  color: #4a5568;\n  border-color: #e2e8f0;\n}\n\n.btn-secondary:hover {\n  background-color: #e2e8f0;\n  color: #2d3748;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .bulk-operation-details-modal {\n    width: 95%;\n    max-height: 90vh;\n  }\n  \n  .details-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .results-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .parameter-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
